var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map-wrapper"},[(_vm.google)?[_vm._t("default",null,{"googleApi":_vm.google})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }